import React, { Fragment } from 'react';
import MenuItem from "@material-ui/core/MenuItem";
import { Divider } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
    maxWidth: 500,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  Button: {
    marginRight: theme.spacing(1),
  }
}));

const NavigationButton = ({ text, siteInfo, orgInfo, tankInfo, branchName, isModuleEditor, currentSiteName = "" }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  let history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRedirect = (id, moduleName) => {
    try {
      setAnchorEl(null);
      var orgName = orgInfo.orgName;
      if (id === "createNew") {
        if (tankInfo === undefined) {
          history.push('/orgs/' + orgName + '/branches/' + branchName + '/new/');
        }
        else {
          history.push('/orgs/' + orgName + '/branches/' + branchName + '/sites/' + currentSiteName + '/new/');
        }
      }
      else if (tankInfo === undefined || tankInfo.length === 0) {
        // Site navigation
        // TODO: Improve, this doesn't need to for-loop everytime
        for (var i = 0; i < siteInfo.siteData.length; i++) {
          //var branchName = siteInfo.siteData[i].BranchName;
          var siteName = siteInfo.siteData[i].SiteName;
          var siteId = siteInfo.siteData.Site_id;
          if (moduleName === siteName) {
            history.push('/orgs/' + orgName + '/branches/' + branchName + '/sites/' + moduleName);
            break;
          }
        }
      } else {
        // Tank navigation

        for (var i = 0; i < siteInfo.siteData.length; i++) {
          //var branchName = siteInfo.siteData[i].BranchName;  //CI:  Branch name is static for this button.
          var siteName = siteInfo.siteData[i].SiteName;
          var tankName = siteInfo.siteData[i].name;
          if (moduleName === tankName) {
            history.push('/orgs/' + orgName + '/branches/' + branchName + '/sites/' + siteName + '/tanks/' + moduleName);
            break;
          }
        }
      }
    } catch (e) {
    }
  };

  var menuItems = {};

  try {
    if (tankInfo === undefined || tankInfo.length === 0 && text !== 'TANKS') {
      // Site menu items
      for (var i = 0; i < siteInfo.sitesList.length; i++) {
        menuItems[i] = siteInfo.sitesList[i];
      }
    } else {
      // Tank menu items
      for (var i = 0; i < tankInfo.tanksList.length; i++) {
        menuItems[i] = tankInfo.tanksList[i];
      }
    }
  } catch (e) {
    console.log(e);
  }

  return (
    <Fragment>
      <Button className={classes.Button} variant="outlined" color="primary" onClick={handleClick}>
        {text}
      </Button>
      <Menu
        id="navigation-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleRedirect} >
        {Object.entries(menuItems).map(([key, value]) =>
          <MenuItem key={key} value={value} onClick={() => handleRedirect(key, value)}>
            {value}
          </MenuItem>
        )}
        {isModuleEditor && <Divider />}
        {(isModuleEditor) && <MenuItem key="createNew" value={(tankInfo === undefined || tankInfo.length === 0) ? "+ " + t("createSite") : "+ " + t("createTank")} onClick={() => handleRedirect("createNew", "value")}>
          {(tankInfo === undefined || tankInfo.length === 0) ? "+ " + t("createNewSite") : "+ " + t("createNewTank")}
        </MenuItem>}
      </Menu>
    </Fragment>
  );
};

export default NavigationButton;